export default __webpack_public_path__ + "static/N0001-fd64cf26a7c81340d5920781fb5100f3.png";